import React from 'react';

// import components
import FeaturedImage from 'components/partials/featured-image';

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";

const FeaturedImageBuilder: React.FC<{ featuredImageData?: Queries.FeaturedImageBlockFragment }> = ({ featuredImageData }) => {

    if (!featuredImageData) return null;

    let image = isGatsbyImageData(featuredImageData.image?.gatsbyImageData) ? featuredImageData.image?.gatsbyImageData : undefined;
    let alt = featuredImageData.image?.alt || '';

    return (
        <FeaturedImage
            image={image}
            alt={alt}
        />
    );
};

export default FeaturedImageBuilder;